module.exports = __webpack_public_path__ + "static/media/progress_bar_2.9ab6c237.svg";